function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useRef } from 'react';
import { useElementSize, useScrollTo, usePrevProp, useUpdate } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { useLocale, usePrefixCls, useDirection } from '@byte-design/config';
import { CASCADER_PANEL_HEIGHT, CASCADER_PANEL_COLUMN_LIST_HEIGHT, CASCADER_PANEL_COLUMN_TITLE_HEIGHT, useCascader, useCascaderActive, useCascaderItem, useCascaderRoot } from '../../../hooks/cascader';
import { Empty } from '../../empty';
import { CascaderColumn } from './CascaderColumn';
export function CascaderPanelComp(props) {
  var className = props.className,
      renderItem = props.renderItem,
      panelStyle = props.panelStyle,
      panelHeight = props.panelHeight,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent;
  var direction = useDirection();
  var info = useCascaderRoot();
  var activeIds = useCascaderActive();
  var boxRef = useRef(null);
  var innerBoxRef = useRef(null);
  var update = useUpdate();
  var locale = useLocale('cascader.empty');
  var cascader = useCascader();
  var columnWidth = cascader.columnWidth;
  var rowHeight = cascader.rowHeight;
  var rootId = cascader.getRootId();
  var lastId = activeIds.pop();
  var lastInfo = useCascaderItem(lastId || rootId);

  if (lastInfo && !lastInfo.isLeaf && !lastInfo.needLoad && lastId) {
    activeIds.push(lastId);
  }

  var boxSize = useElementSize(boxRef, function () {
    return true;
  }, update);
  var cls = classnames(usePrefixCls('cascader-panel', {
    rtl: direction === 'rtl'
  }), className);
  var innerCls = usePrefixCls('cascader-panel-inner', {
    empty: !info.children || !info.children.length
  });
  var columnCls = usePrefixCls('cascader-column', {
    empty: !info.children || !info.children.length,
    rtl: direction === 'rtl'
  });

  var panelStyleWithHeight = _objectSpread(_objectSpread({}, panelStyle), {}, {
    height: panelHeight !== null && panelHeight !== void 0 ? panelHeight : CASCADER_PANEL_HEIGHT
  });

  var listHeight = panelHeight ? panelHeight - CASCADER_PANEL_COLUMN_TITLE_HEIGHT - 2 : CASCADER_PANEL_COLUMN_LIST_HEIGHT;

  var renderColumns = function renderColumns() {
    if (!info.children || !info.children.length) {
      return React.createElement(CascaderColumn, {
        key: "empty",
        rowHeight: rowHeight,
        className: columnCls,
        parentId: '',
        listHeight: listHeight,
        columnTitle: cascader.getColumnTitle(0, rootId),
        columnWidth: boxSize.width - 2 || undefined
      }, emptyRender ? emptyRender(locale) : React.createElement(Empty, {
        content: emptyContent ? emptyContent(locale) : locale
      }));
    }

    if (activeIds.length) {
      return activeIds.map(function (id, idx) {
        return React.createElement(CascaderColumn, {
          key: id,
          rowHeight: rowHeight,
          parentId: id,
          listHeight: listHeight,
          columnTitle: cascader.getColumnTitle(idx, id),
          renderItem: renderItem,
          columnWidth: activeIds.length === 1 ? boxSize.width - 2 : undefined
        });
      });
    }

    return React.createElement(CascaderColumn, {
      key: info.id,
      rowHeight: rowHeight,
      parentId: info.id,
      listHeight: listHeight,
      columnTitle: cascader.getColumnTitle(0, rootId),
      columnWidth: boxSize.width - 2 || undefined
    });
  };

  var newWidth = activeIds.length > 2 ? activeIds.length * columnWidth : boxSize.width - 2;

  var _usePrevProp = usePrevProp(newWidth),
      _usePrevProp2 = _slicedToArray(_usePrevProp, 2),
      isEqual = _usePrevProp2[0],
      oldWidth = _usePrevProp2[1];

  var _useScrollTo = useScrollTo(boxRef, 'left', activeIds.length > 1 ? (activeIds.length - 1) * columnWidth : 0, 150, function () {
    return boxRef.current !== null;
  }, {
    end: function end() {
      if (innerBoxRef.current && !isEqual) {
        update();
      }
    }
  }),
      startScroll = _useScrollTo.startScroll;

  useEffect(function () {
    startScroll();
  });
  return React.createElement("div", {
    className: cls,
    ref: boxRef,
    style: panelStyleWithHeight
  }, React.createElement("div", {
    className: innerCls,
    ref: innerBoxRef,
    style: {
      width: "".concat(Math.max(newWidth, oldWidth), "px")
    }
  }, renderColumns()));
}